import { Grid, Box, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import QCXFinalDatePickerField from '../../../../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import QCXFinalAlternativeCurrencyField from '../../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField'
import QCXSelectFornecedorAutocomplete from '../../../../../shared-components/select-fornecedor-favorecido-autocomplete/QCXSelectFornecedorAutocomplete.js';
import QCXFinalTextField from '../../../../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalTextFieldAlt from '../../../../../shared-components/final-text-field/QCXFinalTextFieldAlt';

export default function ContasPagarFilterComponent() {

  const { t } = useTranslation();

  return (
    <Box style={{ minWidth: '500px' }}>
      <Grid container title="Seção que contém informações do usuário" spacing={2}>
        {/* 1. Número Processo */}
        <Grid item sm={12}>
          <QCXFinalTextField
            id="numero-processo-field"
            key="numero-processo-field"
            label={t('com.muralis.qcx.NumeroProcesso')}
            name="numero_processo"
            required={undefined}
            validate={undefined}
          />
        </Grid>

        {/* 2. Origem */}
        <Grid item xs={12}>
          <QCXFinalTextFieldAlt
            key="origem"
            id="origem"
            name="origem"
            label="Origem"
            select
          >
            <MenuItem value="">TODOS</MenuItem>
            <MenuItem value="FATURAMENTO">FATURAMENTO</MenuItem>
            <MenuItem value="OPERACIONAL">OPERACIONAL</MenuItem>
            <MenuItem value="ADMINISTRATIVA">ADMINISTRATIVA</MenuItem>
            <MenuItem value="REGISTRO_DI">REGISTRO_DI</MenuItem>
          </QCXFinalTextFieldAlt>
        </Grid>

        {/* 3. Data Solicitação (início / fim) */}
        <Grid item sm={6}>
          <QCXFinalDatePickerField
            id="data-solicitacao-inicio-field"
            key="data-solicitacao-inicio-field"
            label='Data Solicitacao (Início)'
            name="data_solicitacao_pagamento_inicio"
            required={undefined}
            validate={undefined}
          />
        </Grid>
        <Grid item sm={6}>
          <QCXFinalDatePickerField
            id="data-solicitacao-fim-field"
            key="data-solicitacao-fim-field"
            label='Data Solicitacao (Fim)'
            name="data_solicitacao_pagamento_fim"
            required={undefined}
            validate={undefined}
          />
        </Grid>

        {/* 4. Data Aprovação (início / fim) */}
        <Grid item sm={6}>
          <QCXFinalDatePickerField
            id="data-aprovacao-inicio-field"
            key="data-aprovacao-inicio-field"
            label='Data Aprovação (Início)'
            name="data_aprovacao_inicio"
            required={undefined}
            validate={undefined}
          />
        </Grid>
        <Grid item sm={6}>
          <QCXFinalDatePickerField
            id="data-aprovacao-fim-field"
            key="data-aprovacao-fim-field"
            label='Data Aprovação (Fim)'
            name="data_aprovacao_fim"
            required={undefined}
            validate={undefined}
          />
        </Grid>

        {/* 5. Favorecido (fornecedor) */}
        <Grid item xs={12} sm={12} md={12}>
          <QCXSelectFornecedorAutocomplete
            id="select-field-fornecedor"
            key="select-field-fornecedor"
            name="fornecedor_id"
            label="Favorecido"
            initialValues={undefined}
            disabled={undefined}
          />
        </Grid>

        {/* 6. Solicitante */}
        <Grid item sm={12}>
          <QCXFinalTextField
            id="solicitante-field"
            key="solicitante-field"
            label={t('com.muralis.qcx.solicitante')}
            name="solicitante"
            required={undefined}
            validate={undefined}
          />
        </Grid>

        {/* 7. Item Despesa */}
        <Grid item sm={12}>
          <QCXFinalTextField
            id="item-despesa-field"
            key="item-despesa-field"
            label="Item Despesa"
            name="item_despesa"
            required={undefined}
            validate={undefined}
          />
        </Grid>

        {/* 8. Valor a Pagar */}
        <Grid item xs={12} sm={12} md={12}>
          <QCXFinalAlternativeCurrencyField
            id="financeiro-valor-pagar-field"
            key="financeiro-valor-pagar-field"
            name="valor_pagar"
            label={t('com.muralis.qcx.contas_receber.filter.valor_pagar')}
            onBlur={undefined}
            disabled={undefined}
          />
        </Grid>

        {/* 9. Status */}
        <Grid item sm={12}>
          <QCXFinalTextFieldAlt
            key="status"
            id="status"
            name="status"
            label="status"
            select
          >
            <MenuItem value="">TODOS</MenuItem>
            <MenuItem value="PENDENTE">PENDENTE</MenuItem>
            <MenuItem value="PAGO">PAGO</MenuItem>
            <MenuItem value="SALDO_TRANSFERIDO">SALDO_TRANSFERIDO</MenuItem>
            <MenuItem value="ESTORNADO">ESTORNADO</MenuItem>
            <MenuItem value="CANCELADO">CANCELADO</MenuItem>
          </QCXFinalTextFieldAlt>
        </Grid>

        {/* 10. Data Vencimento (início / fim) */}
        <Grid item sm={6}>
          <QCXFinalDatePickerField
            id="data-vencimento-inicio-field"
            key="data-vencimento-inicio-field"
            label='Data Vencimento (Início)'
            name="data_vencimento_inicio"
            required={undefined}
            validate={undefined}
          />
        </Grid>
        <Grid item sm={6}>
          <QCXFinalDatePickerField
            id="data-vencimento-fim-field"
            key="data-vencimento-fim-field"
            label='Data Vencimento (Fim)'
            name="data_vencimento_fim"
            required={undefined}
            validate={undefined}
          />
        </Grid>

        {/* 11. Data Pagamento (início / fim) */}
        <Grid item sm={6}>
          <QCXFinalDatePickerField
            id="data-pagamento-inicio-field"
            key="data-pagamento-inicio-field"
            label='Data Pagamento (Início)'
            name="data_pagamento_inicio"
            required={undefined}
            validate={undefined}
          />
        </Grid>
        <Grid item sm={6}>
          <QCXFinalDatePickerField
            id="data-pagamento-fim-field"
            key="data-pagamento-fim-field"
            label='Data Pagamento (Fim)'
            name="data_pagamento_fim"
            required={undefined}
            validate={undefined}
          />
        </Grid>

        {/* 12. Número Documento */}
        <Grid item sm={12}>
          <QCXFinalTextField
            id="numero-documento-field"
            key="numero-documento-field"
            label="Número Documento"
            name="numero_documento"
            required={undefined}
            validate={undefined}
          />
        </Grid>
      </Grid>
    </Box>
  );
}